import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const Store = new Vuex.Store(
    {
        state: {
            //会员信息
            user: null,
            //是否在首页，是，则展示导航【首页】。另外控制首页一级目录必须展示。
            isShowIndex: false,
            //控制是否展示目录
            isShowCategory: false,
            //记录目录为服务(true)or解决方案(false)，控制非首页点击服务、方案逻辑展示
            isShowServe: true,
            //个人中心索引
            userIndex: 1,
            //搜索词
            searchStr: '',
            //导航索引
            navIndex: 2,
            //关于中安索引
            aboutIndex: 'tab0',
            //登录、注册背景图片
            backImg: ''
        },
        mutations: {
            /**
             * 获取用户登录信息
             * @param state
             * @param userInfo
             */
            setUser(state, userInfo) {
                state.user = userInfo;
            },

            /**
             * 退出
             * @param state
             */
            clearUser(state) {
                state.user = '';
            },

            /**
             * 首页导航是否显示
             * @param state
             * @param isShow
             */
            setIndex(state, isShow) {
                state.isShowIndex = isShow;
            },

            /**
             * 服务是否显示
             * @param state
             * @param isShow
             */
            isShow_serve(state, isShow) {
                state.isShowServe = isShow;
            },

            /**
             * 控制悬浮目录是否显示
             * @param state
             * @param isShow
             */
            setFloatCategory(state, isShow) {
                state.isShowCategory = isShow;
            },

            /**
             * 修改个人中心索引
             * @param state
             * @param index
             */
            modifyUserIndex(state, index) {
                state.userIndex = index
            },

            /**
             * 设置搜索词
             */
            setSearchStr(state, str) {
                state.searchStr = str
            },

            /**
             * 设置导航选中样式
             */
            setNav(state, index) {
                state.navIndex = index
            },

            /**
             * 设置关于中安索引
             */
            setAboutIndex(state, index) {
                state.aboutIndex = index
            },

            /**
             * 设置登录、注册背景图
             */
            setLoginOrRegisterBackImg(state, imgUrl) {
                state.backImg = imgUrl
            }
        }
    }
)

export default Store
